import React from 'react';
import { motion } from 'framer-motion';
import { Layers, PenTool, Share2, Target } from 'lucide-react';
export function Solutions() {
  const solutions = [{
    icon: <Layers size={28} strokeWidth={1.5} data-id="element-184" />,
    title: 'Content Strategy Architecture',
    description: "Research-driven content roadmaps mapped precisely to your buyer's journey. We identify high-intent topics that capture demand, not just traffic.",
    shape: 'clip-hexagon'
  }, {
    icon: <PenTool size={28} strokeWidth={1.5} data-id="element-185" />,
    title: 'Technical Thought Leadership',
    description: 'Deep-dive articles, whitepapers, and reports written by subject matter experts. We translate complex technical concepts into compelling business value.',
    shape: 'clip-triangle'
  }, {
    icon: <Share2 size={28} strokeWidth={1.5} data-id="element-186" />,
    title: 'SEO & Distribution Engineering',
    description: 'Systematic content distribution across organic search, social, and communities. We ensure your content reaches the right stakeholders at the right time.',
    shape: 'rounded-none' // Square
  }, {
    icon: <Target size={28} strokeWidth={1.5} data-id="element-187" />,
    title: 'Revenue Attribution Framework',
    description: 'Connecting content consumption directly to pipeline metrics. We implement tracking to prove exactly how content influences closed-won deals.',
    shape: 'rounded-full' // Circle
  }];
  return <section id="solutions" className="py-24 bg-white relative" data-id="element-188">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-189">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 md:mb-24 gap-8" data-id="element-190">
          <div className="max-w-2xl" data-id="element-191">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="flex items-center gap-3 mb-6" data-id="element-192">
              <div className="w-8 h-[1px] bg-navy-900" data-id="element-193"></div>
              <span className="text-navy-600 font-medium uppercase tracking-wider text-sm" data-id="element-194">
                Our Methodology
              </span>
            </motion.div>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-4xl md:text-5xl font-heading font-bold text-navy-900 leading-tight" data-id="element-195">
              Engineering content that performs.
            </motion.h2>
          </div>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-slate-600 max-w-md" data-id="element-196">
            We don't just write articles. We build comprehensive content systems
            designed specifically for complex B2B sales cycles.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-197">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative" data-id="element-198">
              {/* Decorative background line */}
              <div className="absolute top-8 left-8 right-0 h-px bg-slate-100 -z-10 group-hover:bg-navy-100 transition-colors" data-id="element-199"></div>

              <div className="flex gap-6 md:gap-8" data-id="element-200">
                <div className="flex-shrink-0" data-id="element-201">
                  <div className={`w-16 h-16 bg-navy-50 text-navy-900 flex items-center justify-center group-hover:bg-navy-900 group-hover:text-white transition-all duration-300 ${solution.shape}`} data-id="element-202">
                    {solution.icon}
                  </div>
                </div>
                <div data-id="element-203">
                  <h3 className="text-xl font-heading font-bold mb-3 text-navy-900" data-id="element-204">
                    {solution.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-205">
                    {solution.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}